import { createModule } from "direct-vuex";
import { moduleActionContext } from "..";
import actions from "./actions";
import { SessionState } from "./types";
import { UserResource } from "../user/types";
import { UserManager, WebStorageStateStore } from "oidc-client";
import config from "@/config";

const session = createModule({
  namespaced: true,
  state: (): SessionState => {
    return {
      token: localStorage.getItem("token") || undefined,
      user: undefined,
      welcome: false,
      client: new UserManager({
        userStore: new WebStorageStateStore({
          store: window.localStorage,
        }),
        authority: config.oidc.authority,
        client_id: config.oidc.client_id,
        redirect_uri: window.location.origin + config.path + "/auth-callback.html",
        response_mode: "fragment",
        automaticSilentRenew: true,
        loadUserInfo: false,
        validateSubOnSilentRenew: false,
        silent_redirect_uri: window.location.origin + config.path + "/silent-renew.html",
        response_type: "code",
        scope: config.oidc.scopes,
        post_logout_redirect_uri: window.location.origin + config.path + "/?notify=logout",
        filterProtocolClaims: true,
        extraQueryParams: { kc_idp_hint: "adfs-aguasandinas" }
      }),
    };
  },
  getters: {
    isAdmin(state) {
      return state.user ? state.user.attributes.is_admin : false;
    }
  },
  mutations: {
    SET_TOKEN(state, jwt: string | undefined) {
      state.token = jwt;
      if (jwt != undefined) {
        localStorage.setItem("token", jwt);
      } else {
        localStorage.removeItem("token");
      }
    },
    SET_USER(state, user: UserResource | undefined) {
      state.user = user;
    },
    SET_WELCOME(state, val: boolean) {
      state.welcome = val;
    },
    LOGOUT(state) {
      state.user = undefined;
      state.token = undefined;
      localStorage.removeItem("token");
    }
  },
  actions: actions
});

session.state().client.events.addUserLoaded((user) => {
  session.mutations.SET_TOKEN(session.state(), user.access_token);
});

session.state().client.events.addUserUnloaded(() => {
  session.mutations.SET_TOKEN(session.state(), undefined);
  session.mutations.SET_USER(session.state(), undefined);
});

session.state().client.events.addUserSignedOut(() => {
  session.mutations.SET_TOKEN(session.state(), undefined);
  session.mutations.SET_USER(session.state(), undefined);
});

// this.state.client.events.addAccessTokenExpiring(() => {
//   // Wait 2 minutes for silent renew and set access token
//   console.log("Token is expiring. Queueing silent renew...");
//   setTimeout(async () => {
//     const user = await this.state.client.getUser();
//     this.state.accessToken = user ? user.access_token : null;
//   }, 30000);
// });

export default session;
export const sessionActionContext = (context: any) =>
  moduleActionContext(context, session);
